/**
 * WordPress dependencies
 * @wordpress/i18n for translation functions
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 * - Should basically always be used for any text that is visible to the user
 *
 * @wordpress/element for React components
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-element/
 */
import { __ } from '@wordpress/i18n';

import CourseListItem from './CourseListItem';

/**
 * Example Component
 * @param {Object.data} data Data from UseInfiniteQuery and useRecipes hook
 * @param {Object.currentPage} currentPage The current page of the recipe list
 * @param {Object.isPending} isPending Whether the loading is pending or not (from useIndustries hook)
 * @param {Object.error} error The error of the data fetch (from useRecipes hook)
 * @param {Object.isError} isError Whether the fetch has an error or not (from useIndustries hook)
 * @returns {JSX.Element}
 */
function CourseList({ data, isPending, isError }) {
	if (isPending) {
		return null;
	}

	if (isError) {
		return (
			<div>{__('Error fetching courses.', 'kotisivu-block-theme')}</div>
		);
	}

	return data.map((item) => {
		return (
			<CourseListItem
				key={item.id}
				id={item.id}
				name={item.title}
				description={item.description}
				imageUrl={item.image.url}
				startDate={item.start_date}
				endDate={item.end_date}
				status={item.status}
				venues={item.venues}
				categories={item.categories}
				url={item.url}
				registrationUrl={item.registration_url}
			/>
		);
	});
}

export default CourseList;
